var React = require('react');

function Arrows (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Group 9"),React.createElement("g",{"stroke":"#FFF","strokeWidth":"2","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M9.367 15.55l7.183-6.92-7.183-6.997M1.367 15.55L8.55 8.63 1.367 1.633"}))]);
}

Arrows.displayName = "Arrows";

Arrows.defaultProps = {"viewBox":"0 0 18 17"};

module.exports = Arrows;

Arrows.default = Arrows;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrows.svg
// module id = 1257
// module chunks = 0